<template>
  <div class="detection-container">
    <el-button
      v-if="isCanDetection"
      type="primary"
      class="btn-check-reabck"
      @click="checkReback"
    >
      智能检测
    </el-button>
    <div
      v-if="isChecked"
      class="detection-result-content"
    >
      <template v-if="isImgDetection">
        <div class="img-detection-list">
          <div
            v-for="(item, index) in listData"
            :key="index"
            :class="['item', { 'item-error': item.subType.length !== 0 }]"
          >
            <h5>
              <span>{{ item.type }}</span><span>{{ item.conclusion }}</span>
            </h5>
            <ul v-if="item.subType.length !== 0">
              <li
                v-for="(sub, subIndex) in item.subType"
                :key="subIndex"
              >
                <span>{{ sub.name }}</span>
                <span>{{ sub.conclusion }}</span>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-else-if="isVideo">
        <div
          v-if="isJlxk"
          class="detection-result"
        >
          检测结果：<span v-if="check_porn">色情占比{{ pornRatio }}%；</span><span v-if="check_terrorism">涉政占比{{ terrorismRatio }}%；</span><span v-if="check_ad">广告占比{{ adRatio }}%；</span><span v-if="check_live">不良场景占比{{ liveRatio }}%；</span>正常占比{{ normalRatio }}%
        </div>
        <ul
          v-else
          class="detection-result_jgsd"
        >
          <li
            v-for="(item, index) in jgsdCheckResult"
            :key="index"
            :class="{
              active: item.label !== '0.00' && item.name !== '正常占比'
            }"
          >
            {{ item.name }}<span>{{ item.label }}%</span>
          </li>
        </ul>
        <div
          class="empty"
          v-if="isDetectionPass"
        >
          <img :src="imageSuccess">
          <h6>无违规内容</h6>
        </div>
        <div
          class="detection-list"
          v-else
        >
          <el-timeline>
            <el-timeline-item
              placement="top"
              v-for="(item, index) in listData"
              :key="index"
              :timestamp="formatTime(item.offset)"
            >
              <i class="icon jlxk-detail-decetion-icon" />
              <div
                class="el-line-item-content"
                @click="setPlay(item, index)"
                :class="currentPlayIndex === index ? 'activeItem' : ''"
              >
                <el-image :src="item.tempWanUrl" />
                <span
                  class="warning"
                ><i class="icon jlxk-detail-decetion-error" />{{
                  switchLabel(item.label)
                }}</span>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </template>
      <template v-else>
        <div class="audio-check-result">
          检测结果：<em>{{ audioCheckResult }}</em>
        </div>
        <div
          class="empty"
          v-if="audioCheckResult === '合格'"
        >
          <img :src="imageSuccess">
          <h6>无违规内容</h6>
        </div>
        <div
          class="detection-list audio-detection-list"
          v-else
        >
          <el-timeline>
            <el-timeline-item
              placement="top"
              v-for="(item, index) in listData"
              :key="index"
              :timestamp="formatTime(item.items[0].startTimeInSeconds)"
            >
              <i class="icon jlxk-detail-decetion-icon" />
              <div
                class="el-line-item-content"
                @click="setPlay(item, index)"
                :class="currentPlayIndex === index ? 'activeItem' : ''"
              >
                <span class="text">{{ item.items[0].text }}</span>
                <span
                  class="warning audio"
                ><i class="icon jlxk-detail-audio-decetion-error" />{{
                  item.label
                }}</span>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </template>
    </div>
    <div
      class="empty"
      v-else
    >
      <img :src="imageError">
      <h6>此{{ labelName }}暂无检测结果</h6>
    </div>
  </div>
</template>

<script>
import { isCanAcess } from '@common/index.js'
export default {
  name: '',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      checkItem: [
        { name: '色情占比', label: 'pornRatio' },
        { name: '涉政占比', label: 'terrorismRatio' },
        { name: '广告占比', label: 'adRatio' },
        { name: '不良场景占比', label: 'liveRatio' },
        { name: '正常占比', label: 'normalRatio' }
      ],
      listData: [],
      isDetectionPass: true,
      check_porn: false, // 是否检测了色情
      check_terrorism: false, // 是否检测了涉政
      check_live: false, // 是否检测了不良场景
      check_ad: false, // 是否检测了广告
      check_list: ['porn', 'terrorism', 'live', 'ad'],
      pornNum: 0,
      terrorismNum: 0,
      liveNum: 0,
      adNum: 0,
      currentPlayIndex: null,
      imageSuccess: require('@assets/imgs/jlxk/video-detection-success.png'),
      videoError: require('@assets/imgs/jlxk/video-detail-error.png'),
      audioError: require('@assets/imgs/jlxk/audio-detail-error.png'),
      imgError: require('@assets/imgs/jlxk/image-detail-error.png'),
      audioCheckResult: '',
      imgCheckItem: [
        '涉黄审核',
        '暴恐审核',
        '恶心图审核',
        '广告审核',
        '涉政审核',
        '图文审核',
        '不良场景涉黄',
        '违禁图库审核'
      ]
    }
  },
  computed: {
    totalNum() {
      return Math.round(this.detail.duration / 2)
    },
    pornRatio() {
      return ((this.pornNum / this.totalNum) * 100).toFixed(2)
    },
    terrorismRatio() {
      return ((this.terrorismNum / this.totalNum) * 100).toFixed(2)
    },
    liveRatio() {
      return ((this.liveNum / this.totalNum) * 100).toFixed(2)
    },
    adRatio() {
      return ((this.adNum / this.totalNum) * 100).toFixed(2)
    },
    normalRatio() {
      return (
        100 -
        this.pornRatio -
        this.terrorismRatio -
        this.liveRatio -
        this.adRatio
      ).toFixed(2)
    },
    isChecked() {
      return this.detail.checkResult.length !== 0
    },
    type() {
      return this.detail.type
    },
    isImgDetection() {
      return this.type === 'img'
    },
    isVideo() {
      return this.type === 'video'
    },
    labelName() {
      return this.isImgDetection ? '图片' : this.isVideo ? '视频' : '音频'
    },
    imageError() {
      return this.isImgDetection
        ? this.imgError
        : this.isVideo
          ? this.videoError
          : this.audioError
    },
    menusData() {
      return this.$store.state.Menus
    },
    modelId() {
      return this.$route.query.modelId || 0
    },
    // 是否是数据推送
    formUrl() {
      if (this.menusData.length === 0 || this.modelId === 0) return false
      let arr = this.modelId.split('-')
      if (arr.length === 1) {
        return this.menusData[arr[0]].url === '/jlxk/datapush' || false
      }
      let first = this.menusData[arr[0]].children
      let sec = first[arr[1]].url
      return sec === '/jlxk/datapush' || false
    },
    isFirstManager() {
      return (
        login_cookie['departmentId'] === 0 &&
        login_cookie['userType'] === 1 &&
        !this.formUrl
      )
    },
    isJlxk() {
      let jlxk = ['/jlxk/image', '/jlxk/video']
      return jlxk.indexOf(this.$route.path) !== -1
    },
    isJgsd() {
      let jgsd = ['/jgsd/image', '/jgsd/video']
      return jgsd.indexOf(this.$route.path) !== -1
    },
    isCanDetection() {
      return (
        (this.isJlxk && this.isFirstManager) ||
        (this.isJgsd && isCanAcess('/jgsd/review'))
      )
    },
    jgsdCheckResult() {
      return this.checkItem.map(item => {
        return {
          name: item.name,
          label: this[item.label]
        }
      })
    }
  },
  created() {},
  mounted() {},
  methods: {
    formatTime(val) {
      // 后台传的单位是秒
      let res = ''
      let duration = val
      let hour, minute, second
      hour = Math.floor(duration / 3600) % 60
      minute = Math.floor(duration / 60) % 60
      second = Math.floor(duration) % 60
      if (hour !== 0) {
        res = hour + ':' + (minute < 10 ? '0' + minute : minute) + ':' + second
      } else {
        res =
          '00:' +
          (minute !== 0 ? minute : '00') +
          ':' +
          (second < 10 ? '0' + second : second)
      }
      return res
    },
    switchLabel(value) {
      let result = ''
      switch (value) {
        case 'ad':
          result = '广告'
          break
        case 'porn':
          result = '色情'
          break
        case 'live':
          result = '不良场景'
          break
        default:
          result = '涉政'
          break
      }
      return result
    },
    setPlay(item, index) {
      this.currentPlayIndex = index
      this.$emit('handlePlay', item.offset)
    },
    // 重新检测
    checkReback() {
      this.$emit('checkReback')
    }
  },
  watch: {
    detail: {
      handler(newVal) {
        if (this.isImgDetection) {
          this.listData = this.imgCheckItem.map((item, index) => {
            return {
              type: item,
              conclusion: '合规',
              subType: []
            }
          })
          if (newVal.checkResult && newVal.checkResult.length !== 0) {
            newVal.checkResult.forEach(item => {
              let index = this.listData.findIndex(
                i => i.type === item.typeName
              )
              if (index !== -1) {
                let result = this.listData[index]
                let subType = this.listData[index].subType
                subType.push({
                  name: item.subTypeName,
                  conclusion: item.conclusion
                })
                this.listData[index] = Object.assign({}, result, {
                  conclusion: this.detail.conclusion,
                  subType: subType
                })
              }
            })
          }
          return false
        }
        if (this.detail.checkResult.length === 0) {
          this.listData = []
          return false
        }
        if (newVal.type === 'video') {
          this.check_list.forEach(item => {
            this['check_' + item] = false
          })
          this.listData = []
          this.isDetectionPass = true
          newVal.checkResult.forEach(item => {
            this['check_' + item.scene] = true
            let list = item.frames || []
            this[item.scene + 'Num'] = list.length
            if (item.suggestion !== 'pass') {
              this.isDetectionPass = false
            }
            list.forEach(inner => {
              this.listData.push(inner)
            })
          })
        } else {
          this.audioCheckResult =
            newVal.checkResult[0].label === '合规' ? '合格' : '不合格'
          this.listData = newVal.checkResult[0].audioSegments[0].result
          console.log(newVal.checkResult)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.detection-container {
  .btn-check-reabck {
    margin: 10px 0 0 0;
    border-radius: 2px;
    padding: 6px 10px;
  }
  .detection-result-content {
    margin-top: 10px;
    .detection-result {
      margin-top: 20px;
    }
  }
  .detection-result {
    padding: 10px 13px;
    background: #f5f5f5;
    color: #e02f2f;
    line-height: 18px;
    font-size: 13px;
    &_jgsd {
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 33px;
        padding: 0 9px;
        border-bottom: 1px solid #dcdcdc;
        font-size: 13px;
        &.active {
          color: #d40a0a;
        }
      }
    }
  }
  .audio-check-result {
    height: 40px;
    background: #edf0f7;
    line-height: 40px;
    padding-left: 12px;
    font-size: 13px;
    em {
      color: #4497ec;
      font-style: normal;
    }
  }
  /deep/ .el-timeline {
    max-height: calc(100vh - 240px);
    overflow-y: auto;
    &-item {
      &__timestamp {
        padding-left: 43px !important;
      }
      &__content {
        margin-left: 20px !important;
        i.jlxk-detail-decetion-icon {
          position: absolute;
          top: 0;
        }
        .el-line-item-content {
          display: flex;
          justify-content: space-between;
          padding: 10px 14px;
          background: #f5f5f5;
          border: 1px solid #ececec;
          min-height: 30px;
          line-height: 20px;
          align-items: center;
          &.activeItem {
            background: #eaf3fb;
          }
          .el-image {
            width: 140px;
            height: 80px;
            background: #000000;
          }
          .text {
            font-size: 12px;
            color: #666;
            line-height: 18px;
          }
          .warning {
            font-size: 13px;
            i {
              margin-right: 5px;
            }
            &.audio {
              margin-left: 15px;
              flex-shrink: 0;
              color: #fd9b1c;
            }
          }
        }
      }
    }
  }
  .audio-detection-list {
    /deep/ .el-timeline {
      &-item {
        &__content {
          .el-line-item-content {
            align-items: flex-start;
          }
        }
      }
    }
  }
  .img-detection-list {
    .item {
      h5,
      ul li {
        display: flex;
        height: 33px;
        align-items: center;
        border-bottom: 1px solid #dcdcdc;
        justify-content: space-between;
        font-size: 13px;
      }
      h5 {
        padding: 0 8px;
        span {
          &:last-child {
            color: #242424;
          }
        }
      }
      &.item-error {
        h5 {
          span {
            color: #d40a0a;
          }
        }
        color: #d40a0a;
        ul {
          li {
            padding: 0 8px 0 23px;
          }
        }
      }
    }
  }
}
</style>
